import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import "./admin-reservation.scss";
import "./reservation.scss";
import { ReserveLists, ToursTab } from "./Tabs";
import EditModals from "./Modals";

import { getModalInfo, getTours, saveReservation } from "services/reservation";
import { ReservationContextProvider } from "./ReservationContext";

export default function Index() {
  const [users, setUsers] = useState([]);
  const [id, setId] = useState(-1);

  return (
    <ReservationContextProvider>
      <div className="admin-reservation-container px-sm-3 w-100">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#active-tour-list" type="button" role="tab" aria-controls="home" aria-selected="true">
              لیست رزرو تورهای فعال
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#tour-list-history" type="button" role="tab" aria-controls="profile" aria-selected="false">
              سابقه
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="" data-bs-toggle="tab" data-bs-target="#tours-tab" type="button">
              تور ها
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <ReserveLists />
          <ToursTab />
        </div>
        {ReactDOM.createPortal(
          <EditModals
            users={users}
            tour={{ title: "کیش", price: 1000000, discount: 100000 }}
            additionalCosts={[
              { id: 1, title: "ترنسفر تا مبدا حرکت", price: 300000 },
              { id: 2, title: "تور لیدر", price: 200000 },
            ]}
          />,
          document.querySelector(".modals")
        )}
      </div>
    </ReservationContextProvider>
  );
}
